import React from "react";

export function LoadingScreen() {
    return <div className={'bg-warning'}>Loading ...</div>
}
